module.exports = __webpack_public_path__ + "static/img/purchase_invoices.cf9715c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/purchase_invoices.svg
// module id = 3qCC
// module chunks = 1